import React, { FC } from 'react';
import { css } from '@emotion/css';
import Image from 'next/image';
import check from 'evcharging/assets/ev-software/check.png';

interface DecorListProps {
  items: string[];
}

const DecorList: FC<DecorListProps> = (props) => {
  const { items } = props;
  return (
    <ul className={styles.root}>
      {items.map((item) => (
        <li key={item}>
          <Image src={check} alt={item} width={25} height={25} />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
};

const styles = {
  root: css`
    list-style: none;
    li {
      display: flex;
      align-items: start;
      color: #252c32;
      font-weight: 500;
      font-size: 18px;
      line-height: 150%;
      margin-bottom: 16px;

      img {
        width: 25px;
        height: 25px;
      }

      span {
        display: block;
        margin-left: 8px;
      }
    }
  `,
};

export default DecorList;
